import ModalForm from "./ModalForm.component.jsx";

export default ModalForm;